import _toConsumableArray from "/Users/fafee/Work/Loginet/InternalPortal/internal-portal/portal-client/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.find-last.js";
import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue";
var _hoisted_1 = {
  class: "w-full flex justify-between items-center py-[14px] px-5 bg-surface-0 border-b border-surface-200 relative lg:static"
};
var _hoisted_2 = {
  class: "flex items-center gap-2 overflow-x-auto whitespace-nowrap flex-1 min-w-0"
};
var _hoisted_3 = {
  class: "cursor-pointer flex items-center justify-center text-surface-700 shrink-0 text-sm lg:hidden"
};
var _hoisted_4 = {
  class: "cursor-pointer lg:flex items-center justify-center text-surface-700 shrink-0 text-sm hidden"
};
var _hoisted_5 = {
  key: 1,
  class: "capitalize"
};
var _hoisted_6 = {
  key: 2,
  class: "text-muted-color"
};
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useAppBreakpoints } from "@/composables/useAppBreakpoints";
export default {
  __name: 'TopMenu',
  setup: function setup(__props) {
    var route = useRoute();
    var _useAppBreakpoints = useAppBreakpoints(),
      isMobile = _useAppBreakpoints.isMobile;
    var breadcrumbs = computed(function () {
      var meta = route.meta;
      return typeof meta.breadcrumb === "function" ? meta.breadcrumb(route) : meta.breadcrumb || [];
    });
    var visibleBreadcrumbs = computed(function () {
      if (isMobile.value && breadcrumbs.value.length > 0) {
        return [breadcrumbs.value[breadcrumbs.value.length - 1]];
      }
      return breadcrumbs.value;
    });
    return function (_ctx, _cache) {
      var _breadcrumbs$value, _breadcrumbs$value2, _breadcrumbs$value3;
      var _component_Divider = _resolveComponent("Divider");
      var _component_Button = _resolveComponent("Button");
      var _component_router_link = _resolveComponent("router-link");
      var _directive_styleclass = _resolveDirective("styleclass");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("nav", _hoisted_2, [_withDirectives((_openBlock(), _createElementBlock("a", _hoisted_3, _toConsumableArray(_cache[0] || (_cache[0] = [_createElementVNode("i", {
        class: "fa-regular fa-sidebar max-lg:!text-lg"
      }, null, -1)])))), [[_directive_styleclass, {
        selector: '#app-sidebar-1',
        enterFromClass: 'hidden',
        enterActiveClass: 'animate-fadeinleft',
        leaveToClass: 'hidden',
        leaveActiveClass: 'animate-fadeoutleft',
        hideOnOutsideClick: true
      }]]), _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_4, _toConsumableArray(_cache[1] || (_cache[1] = [_createElementVNode("i", {
        class: "fa-regular fa-sidebar max-lg:!text-lg"
      }, null, -1)])))), [[_directive_styleclass, {
        selector: '#app-sidebar-1',
        enterFromClass: 'lg:hidden',
        leaveToClass: 'lg:hidden',
        hideOnOutsideClick: true
      }]]), _createVNode(_component_Divider, {
        layout: "vertical",
        class: "m-0"
      }), (_breadcrumbs$value = breadcrumbs.value) !== null && _breadcrumbs$value !== void 0 && _breadcrumbs$value.findLast(function (i) {
        return i.to;
      }) ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        to: (_breadcrumbs$value2 = breadcrumbs.value) === null || _breadcrumbs$value2 === void 0 || (_breadcrumbs$value2 = _breadcrumbs$value2.findLast(function (i) {
          return i.to;
        })) === null || _breadcrumbs$value2 === void 0 ? void 0 : _breadcrumbs$value2.to
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_Button, {
            icon: "fa-regular fa-arrow-left",
            variant: "text",
            severity: "contrast",
            size: "small",
            class: "!text-surface-700 hover:!bg-transparent"
          })];
        }),
        _: 1
      }, 8, ["to"])) : _createCommentVNode("", true), (_breadcrumbs$value3 = breadcrumbs.value) !== null && _breadcrumbs$value3 !== void 0 && _breadcrumbs$value3.findLast(function (i) {
        return i.to;
      }) ? (_openBlock(), _createBlock(_component_Divider, {
        key: 1,
        layout: "vertical",
        class: "m-0"
      })) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleBreadcrumbs.value, function (item, i) {
        return _openBlock(), _createElementBlock("span", {
          key: i,
          class: "font-bold text-sm flex items-center gap-2"
        }, [item.to ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: item.to,
          class: "capitalize text-primary-600"
        }, {
          default: _withCtx(function () {
            return [_createTextVNode(_toDisplayString(_ctx.$tf(item.label)), 1)];
          }),
          _: 2
        }, 1032, ["to"])) : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$tf(item.label)), 1)), i < visibleBreadcrumbs.value.length - 1 ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toConsumableArray(_cache[2] || (_cache[2] = [_createElementVNode("i", {
          class: "fa-regular fa-slash-forward"
        }, null, -1)])))) : _createCommentVNode("", true)]);
      }), 128)), _cache[3] || (_cache[3] = _createElementVNode("div", {
        id: "top-menu-breadcrumb-extras",
        class: "flex items-center gap-2"
      }, null, -1))]), _cache[4] || (_cache[4] = _createElementVNode("div", {
        id: "top-menu-actions"
      }, null, -1))]);
    };
  }
};